import { render, staticRenderFns } from "./assegnazionePremiModal.vue?vue&type=template&id=10bbb38e&"
import script from "./assegnazionePremiModal.vue?vue&type=script&lang=ts&"
export * from "./assegnazionePremiModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports